export default __webpack_public_path__ + "static/media/milk.ffc71f74.png";